import { ProgressBar } from '@components/progress-bar';

import { TravellerJourneyListItem } from 'api/types';

export const ProgressCell = ({ row: traveller }: { row: TravellerJourneyListItem }) => {
  return (
    <ProgressBar
      ratio={traveller.progress}
      variant={traveller.status === 'paused' ? 'paused' : undefined}
    />
  );
};
